import React, { useState } from 'react';
import tw from 'twin.macro';
import { Button } from '../button';
import { TimesIcon, SearchIcon } from 'icons';
import { SearchForm } from '../form';

export const ToggleSearchForm = ({ ...props }) => <Button {...props} />;

export const MobileSearchHeader = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <>
      <ToggleSearchForm
        iconProps={{ Type: toggle ? TimesIcon : SearchIcon }}
        onClick={() => {
          setToggle(!toggle);
        }}
      />
      <div
        css={[
          tw`bg-black h-14 px-4 flex items-center absolute top-14 left-0 right-0 -translate-x-full transition-all`,
          toggle && tw`translate-x-0`,
        ]}
      >
        <SearchForm focused={toggle} setOpen={setToggle} />
      </div>
    </>
  );
};
